import { adminApi } from '@kardume/services';
import type { MerchantImageTarget } from '@kardume/types';
import type { ImageUploadPayload } from '@kardume/ui';

/**
 * Uploads a picked image to the merchant image endpoint and resolves to its
 * public URL - the `onUpload` contract of `ImageUpload`/`GalleryInput`.
 *
 * Shared because more than one screen stores a URL returned by this endpoint
 * (store profile images and the ad cover), and both must send the payload the
 * same way.
 */
export const uploadMerchantImage =
  (target: MerchantImageTarget) =>
  async (payload: ImageUploadPayload): Promise<string> => {
    const res = await adminApi.uploadProfileImage({
      image: { base64: payload.base64, contentType: payload.contentType, extension: payload.extension },
      target,
    });
    return res.url;
  };
